import { FormEvent, useContext, useState } from "react";
import { Button, Loader } from "../Styles";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { toast } from "react-toastify";
import { paramsIndicadorMensuracaoLista } from "../../interfaces/indicadorMensuracao";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { atualizarIndicadorMensuracao, cadastrarIndicadorMensuracao } from "../../services/indicadoresMensuracao";
import { useLocation } from "react-router-dom";
import { converterNumero, criptografarDado, moedaMascara } from "../../helpers";
import "./modalMensuracao.css"

function ModalIndicadorMensuracao({ indicador, mensuracao }: paramsIndicadorMensuracaoLista) {
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)
  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");
  const idIndicador = indicador.idIndicador.toString()

  const [processando, setProcessando] = useState(false);

  const [competencia, setCompetencia] = useState(mensuracao?.competencia.slice(0, 7) || '');
  const [faturamento, setFaturamento] = useState(moedaMascara(mensuracao?.faturamento) || '')
  const [despesasOperacionais, setDespesasOperacionais] = useState(moedaMascara(mensuracao?.despesasOperacionais) || '');

  const [investimentos, setInvestimentos] = useState(moedaMascara(mensuracao?.investimentos) || '');
  const [participacoes, setParticipacoes] = useState(moedaMascara(mensuracao?.participacoes) || '');
  const [contasReceber, setContasReceber] = useState(moedaMascara(mensuracao?.contasReceber) || '');

  const [contasPagar, setContasPagar] = useState(moedaMascara(mensuracao?.contasPagar) || '')
  const [compras, setCompras] = useState(moedaMascara(mensuracao?.compras) || '');

  const [estoqueMedio, setEstoqueMedio] = useState(moedaMascara(mensuracao?.estoqueMedio) || '');
  const [cmv, setCmv] = useState(moedaMascara(mensuracao?.cmv) || '');

  const [despesasPrevista, setDespesasPrevista] = useState(moedaMascara(mensuracao?.despesasPrevista) || '');

  const [custoFixo, setCustoFixo] = useState(moedaMascara(mensuracao?.custoFixo) || '');
  const [margemContribuicao, setMargemContribuicao] = useState(moedaMascara(mensuracao?.margemContribuicao) || '');
  const [lucroPretendido, setLucroPretendido] = useState(moedaMascara(mensuracao?.lucroPretendido) || '');
  const [investimento, setInvestimento] = useState(moedaMascara(mensuracao?.investimento) || '');

  const handleSubmit = async (e: FormEvent) => {
    if (!idIndicador) return toast.error("Indicador não encontrado.")
    if (!idProjeto) return toast.error("Projeto não encontrado.")
    e.preventDefault()
    setProcessando(true)

    try {

      const payload = {
        idProjeto,
        idIndicador,
        competencia,
        faturamento: converterNumero(faturamento),
        despesasOperacionais: converterNumero(despesasOperacionais),
        investimentos: converterNumero(investimentos),
        participacoes: converterNumero(participacoes),
        contasReceber: converterNumero(contasReceber),
        contasPagar: converterNumero(contasPagar),
        compras: converterNumero(compras),
        estoqueMedio: converterNumero(estoqueMedio),
        cmv: converterNumero(cmv),
        despesasPrevista: converterNumero(despesasPrevista),
        custoFixo: converterNumero(custoFixo),
        margemContribuicao: converterNumero(margemContribuicao),
        lucroPretendido: converterNumero(lucroPretendido),
        investimento: converterNumero(investimento),
      }
      const resposta = await cadastrarIndicadorMensuracao(payload)

      if (resposta.status === 201) {
        setProcessando(false)
        atualizarDados()
        modalExibir("")
        return toast.success("Indicador Mensuracao Cadastrado com Sucesso.")
      }
    } catch (error: any) {
      if (error.status === 409) {
        setProcessando(false)
        return toast.warn("Já existe uma mensuração cadastrada para essa competência. Por favor, atualize a existente ou escolha outra data.")
      }
      toast.error("Erro ao Cadastrar Indicador Mensuracao")
    }
  }

  const handleUpdate = async (e: FormEvent) => {
    e.preventDefault();
    setProcessando(true);
    try {
      if (!mensuracao) return toast.error("Mensuracao não encontrada.")
      if (!idIndicador) return toast.error("Indicador não encontrado.")
      if (!idProjeto) return toast.error("Projeto não encontrado.")
      const idMensuracao = criptografarDado(mensuracao.id.toString())

      const payload = {
        competencia,
        idProjeto,
        idIndicador: criptografarDado(idIndicador),
        faturamento: converterNumero(faturamento),
        despesasOperacionais: converterNumero(despesasOperacionais),
        investimentos: converterNumero(investimentos),
        participacoes: converterNumero(participacoes),
        contasReceber: converterNumero(contasReceber),
        contasPagar: converterNumero(contasPagar),
        compras: converterNumero(compras),
        estoqueMedio: converterNumero(estoqueMedio),
        cmv: converterNumero(cmv),
        despesasPrevista: converterNumero(despesasPrevista),
        custoFixo: converterNumero(custoFixo),
        margemContribuicao: converterNumero(margemContribuicao),
        lucroPretendido: converterNumero(lucroPretendido),
        investimento: converterNumero(investimento),
      };

      const resposta = await atualizarIndicadorMensuracao(idMensuracao, payload);

      if (resposta.status === 200) {
        setProcessando(false);
        atualizarDados();
        modalExibir("")
        return toast.success("Mensuração atualizada com sucesso.");
      }
    } catch (error: any) {
      setProcessando(false);
      if (error.status === 404) {
        return toast.warn("Mensuração não encontrada.");
      }
      if (error.status === 409) {
        setProcessando(false)
        return toast.warn("Já existe uma mensuração cadastrada para essa competência. Por favor, atualize a existente ou escolha outra data.")
      }
      return toast.error("Erro ao atualizar mensuração.");
    }
  };

  return (
    <div className="fundoModal">
      <section className='containerModalCentro'>
        <span id='novoContainerTitulo'>
          <BsFileEarmarkBarGraph className='adicionarModalIcone' title="Icone Indicador Mensuracao" />
          <p>{mensuracao ? "Editar Mensuração" : "Nova Mensuração"}</p>
        </span>
        <form id='formModalNovo' onSubmit={mensuracao ? handleUpdate : handleSubmit}>
          <section>
            <span>
              <label>Competência</label>
              <input type="month" placeholder="Selecione a Competencia" onChange={(e) => setCompetencia(e.target.value)} defaultValue={competencia} required />
            </span>
          </section>
          {["fat", "lo", "ll", "pmr", "co", "cf", "gc", "cmo", "ii", "ia", "ir"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Faturamento</label>
              <input
                id='valorTransferencia'
                value={faturamento}
                placeholder='R$ 0,00'
                onChange={(e) => setFaturamento(moedaMascara(e.target.value))}
                type="text"
                maxLength={16}
                required />
            </span>
          </section>}
          {["lo", "ll"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Despesas Operacionais</label>
              <input
                value={despesasOperacionais}
                onChange={(e) => setDespesasOperacionais(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["ll"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Investimentos</label>
              <input
                value={investimentos}
                onChange={(e) => setInvestimentos(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["ll"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Participações</label>
              <input
                value={participacoes}
                onChange={(e) => setParticipacoes(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["pmr", "co", "cf", "gc", "cmo", "ii", "ia"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Contas a receber</label>
              <input
                value={contasReceber}
                onChange={(e) => setContasReceber(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["pmp", "cf", "gc", "cmo"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Contas a pagar</label>
              <input
                value={contasPagar}
                onChange={(e) => setContasPagar(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["pmp", "cf", "gc", "cmo"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Compras do ultimo ano</label>
              <input
                value={compras}
                onChange={(e) => setCompras(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["co", "cf", "gc", "cmo"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Estoque Médio</label>
              <input
                value={estoqueMedio}
                onChange={(e) => setEstoqueMedio(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["co", "cf", "gc", "cmo"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Custo da Mercadoria Vendida</label>
              <input
                value={cmv}
                onChange={(e) => setCmv(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["cmo"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Despesas Previstas</label>
              <input
                value={despesasPrevista}
                onChange={(e) => setDespesasPrevista(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["pec", "pef"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Custo Fixo</label>
              <input
                value={custoFixo}
                onChange={(e) => setCustoFixo(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["pec", "pef"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Margem de Contribuição</label>
              <input
                value={margemContribuicao}
                onChange={(e) => setMargemContribuicao(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["pef"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Lucro Pretendido</label>
              <input
                value={lucroPretendido}
                onChange={(e) => setLucroPretendido(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          {["ir"].includes(indicador.indicadore.sigla.toLowerCase()) && <section>
            <span>
              <label>Reinvestimento</label>
              <input
                value={investimento}
                onChange={(e) => setInvestimento(moedaMascara(e.target.value))}
                type="text"
                placeholder="0,00"
                maxLength={16}
                required
              />
            </span>
          </section>}
          <span id="botoesContainer">
            <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalExibir("")}>Fechar</Button>
            <Button type='submit' cor='salvar' isLoading={processando}>
              {!processando && mensuracao ? 'Atualizar' : 'Cadastrar'}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section >
    </div >
  );
}

export default ModalIndicadorMensuracao;